export default __webpack_public_path__ + "static/media/delete_td_btn.1ba12225.png";